// supabaseConfig.js
// Configuración de Supabase para JAVIREPARA

import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://jvvaboqztftxmymdvvim.supabase.co'
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp2dmFib3F6dGZ0eG15bWR2dmltIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY5NDIxNjcsImV4cCI6MjA5MjUxODE2N30.2EuP6kbBsrb-2v4xAMKgRtVJJMrWrPZmOCFHgAViSt8'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)

// Funciones de autenticación
export const signUp = async (email, password) => {
  try {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    })
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

export const signIn = async (email, password) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

export const signOut = async () => {
  try {
    const { error } = await supabase.auth.signOut()
    if (error) throw error
    return { error: null }
  } catch (error) {
    return { error: error.message }
  }
}

export const getCurrentUser = async () => {
  try {
    const { data, error } = await supabase.auth.getUser()
    if (error) throw error
    return data.user
  } catch (error) {
    return null
  }
}

// Funciones de proyectos
export const getProyectos = async (adminId = null) => {
  try {
    let query = supabase
      .from('proyectos')
      .select('*')
      .order('created_at', { ascending: false });
    
    // Si hay adminId, filtrar por él
    if (adminId) {
      query = query.eq('admin_id', adminId);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

export const createProyecto = async (proyecto) => {
  try {
    const { data, error } = await supabase
      .from('proyectos')
      .insert([proyecto])
      .select()
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

export const updateProyecto = async (id, proyecto) => {
  try {
    const { data, error } = await supabase
      .from('proyectos')
      .update(proyecto)
      .eq('id', id)
      .select()
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

export const deleteProyecto = async (id) => {
  try {
    const { error } = await supabase
      .from('proyectos')
      .delete()
      .eq('id', id)
    
    if (error) throw error
    return { error: null }
  } catch (error) {
    return { error: error.message }
  }
}

// Funciones de configuración admin
export const getAdminConfig = async (adminId) => {
  try {
    const { data, error } = await supabase
      .from('config_admin')
      .select('*')
      .eq('admin_id', adminId)
      .single()
    
    if (error && error.code !== 'PGRST116') throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

export const updateAdminConfig = async (adminId, config) => {
  try {
    const { data, error } = await supabase
      .from('config_admin')
      .upsert({
        admin_id: adminId,
        ...config,
        actualizado_el: new Date().toISOString(),
      })
      .select()
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

// Función para subir imágenes
// Función para cambiar contraseña
export const changePassword = async (newPassword) => {
  try {
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    })
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

// ===== FUNCIONES DE TESTIMONIOS =====

// Obtener todos los testimonios (para admin)
export const getTestimonios = async (adminId = null) => {
  try {
    let query = supabase
      .from('testimonios')
      .select('*')
      .order('created_at', { ascending: false });
    
    // NO filtrar por adminId - un admin ve TODOS los testimonios
    // (porque los testimonios públicos tienen admin_id null)
    
    const { data, error } = await query;
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

// Obtener solo testimonios aprobados (para web pública)
export const getTestimoniosPublicos = async (adminId) => {
  try {
    const { data, error } = await supabase
      .from('testimonios')
      .select('*')
      .eq('admin_id', adminId)
      .eq('aprobado', true)
      .order('created_at', { ascending: false })
      .limit(5)
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

// Crear nuevo testimonio (visitante, SIN aprobar automáticamente)
export const createTestimonioPublico = async (testimonio, adminId) => {
  try {
    const { data, error } = await supabase
      .from('testimonios')
      .insert([
        {
          nombre_cliente: testimonio.nombre_cliente,
          email_cliente: testimonio.email_cliente,
          contenido: testimonio.contenido,
          valoracion: testimonio.valoracion || 5,
          aprobado: false,
          estado: 'pendiente',
          admin_id: adminId,
        },
      ])
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

// Aprobar un testimonio
export const aprobarTestimonio = async (id) => {
  try {
    const { data, error } = await supabase
      .from('testimonios')
      .update({ aprobado: true })
      .eq('id', id)
      .select()
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

// Eliminar un testimonio
export const deleteTestimonio = async (id) => {
  try {
    const { error } = await supabase
      .from('testimonios')
      .delete()
      .eq('id', id)
    
    if (error) throw error
    return { error: null }
  } catch (error) {
    return { error: error.message }
  }
}

// ========================================
// FUNCIONES PARA CONFIG ADMIN Y PRUEBAS SOCIALES
// ========================================

// Obtener configuración del admin
export const getConfigAdmin = async (adminId = null) => {
  try {
    let query = supabase.from('config_admin').select('*');
    
    if (adminId) {
      query = query.eq('admin_id', adminId);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    // Retornar primer registro si existe
    return { data: data && data.length > 0 ? data[0] : null, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

// Guardar o actualizar configuración del admin
export const saveConfigAdmin = async (adminId, config) => {
  try {
    // Intentar actualizar primero
    const { data: existing } = await supabase
      .from('config_admin')
      .select('id')
      .eq('admin_id', adminId)
      .single()
    
    if (existing) {
      // Actualizar
      const { data, error } = await supabase
        .from('config_admin')
        .update({
          nombre_completo: config.nombre_completo,
          telefono: config.telefono,
          ciudad: config.ciudad,
          email_contacto: config.email_contacto,
          anos_experiencia: config.anos_experiencia,
          num_reformas: config.num_reformas,
          valoracion: config.valoracion,
          hero_titulo: config.hero_titulo,
          hero_subtitulo: config.hero_subtitulo,
          hero_cta_texto: config.hero_cta_texto,
          actualizado_el: new Date().toISOString()
        })
        .eq('admin_id', adminId)
        .select()
      
      if (error) throw error
      return { data, error: null }
    } else {
      // Insertar
      const { data, error } = await supabase
        .from('config_admin')
        .insert({
          admin_id: adminId,
          ...config
        })
        .select()
      
      if (error) throw error
      return { data, error: null }
    }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

// ========================================
// FUNCIONES PARA INFO JAVIER
// ========================================

// Obtener información de Javier
export const getInfoJavier = async (adminId = null) => {
  try {
    let query = supabase.from('info_javier').select('*');
    
    if (adminId) {
      query = query.eq('admin_id', adminId);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    // Retornar primer registro si existe
    return { data: data && data.length > 0 ? data[0] : null, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

// Guardar o actualizar información de Javier
export const saveInfoJavier = async (adminId, info) => {
  try {
    const { data: existing } = await supabase
      .from('info_javier')
      .select('id')
      .eq('admin_id', adminId)
      .single()
    
    if (existing) {
      const { data, error } = await supabase
        .from('info_javier')
        .update({
          biografia: info.biografia,
          foto_url: info.foto_url,
          actualizado_el: new Date().toISOString()
        })
        .eq('admin_id', adminId)
        .select()
      
      if (error) throw error
      return { data, error: null }
    } else {
      const { data, error } = await supabase
        .from('info_javier')
        .insert({
          admin_id: adminId,
          ...info
        })
        .select()
      
      if (error) throw error
      return { data, error: null }
    }
  } catch (error) {
    return { data: null, error: error.message }
  }
}


// Alias para compatibilidad
export const createTestimonio = createTestimonioPublico;

// Actualizar testimonio (aprobar/rechazar)
export const updateTestimonio = async (id, updates) => {
  try {
    const { data, error } = await supabase
      .from('testimonios')
      .update(updates)
      .eq('id', id)
      .select()
    
    if (error) throw error
    return { data, error: null }
  } catch (error) {
    return { data: null, error: error.message }
  }
}

// ========================================
// FUNCIONES PARA SUPABASE STORAGE
// ========================================

// Subir imagen a Storage y retornar URL pública
export const uploadImage = async (file, folder = 'proyectos') => {
  try {
    const fileExt = file.name.split('.').pop();
    const fileName = `${folder}/${Date.now()}_${Math.random().toString(36).substring(7)}.${fileExt}`;
    
    const { data, error } = await supabase.storage
      .from('proyectos-imagenes')
      .upload(fileName, file);
    
    if (error) throw error;
    
    // Obtener URL pública
    const { data: { publicUrl } } = supabase.storage
      .from('proyectos-imagenes')
      .getPublicUrl(fileName);
    
    return { url: publicUrl, error: null };
  } catch (error) {
    return { url: null, error: error.message };
  }
};

// Eliminar imagen de Storage
export const deleteImage = async (url) => {
  try {
    // Extraer path del URL
    const path = url.split('/proyectos-imagenes/')[1];
    if (!path) return { error: 'URL inválida' };
    
    const { error } = await supabase.storage
      .from('proyectos-imagenes')
      .remove([path]);
    
    if (error) throw error;
    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
};

// ========================================
// FUNCIONES PARA FAQs
// ========================================

// Obtener todas las FAQs (públicas: solo visibles)
export const getFaqs = async () => {
  try {
    const { data, error } = await supabase
      .from('faqs')
      .select('*')
      .eq('visible', true)
      .order('orden', { ascending: true });
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

// Obtener todas las FAQs (admin: incluye no visibles)
export const getFaqsAdmin = async (adminId) => {
  try {
    const { data, error } = await supabase
      .from('faqs')
      .select('*')
      .eq('admin_id', adminId)
      .order('orden', { ascending: true });
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

// Crear FAQ
export const createFaq = async (faq) => {
  try {
    const { data, error } = await supabase
      .from('faqs')
      .insert([faq])
      .select();
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

// Actualizar FAQ
export const updateFaq = async (id, updates) => {
  try {
    const { data, error } = await supabase
      .from('faqs')
      .update(updates)
      .eq('id', id)
      .select();
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

// Eliminar FAQ
export const deleteFaq = async (id) => {
  try {
    const { error } = await supabase
      .from('faqs')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
};
